/* eslint-disable no-extend-native */

import { format } from 'date-fns'

import { getLocalization } from './getLocale'

export function formatReportDate(date: Date): string {
  return format(date, `${getLocalization().dateFormat} 'at' p`)
}

declare global {
  interface Date {
    isEmpty(): boolean
    isNotEmpty(): boolean
  }
}

const reISO =
  /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)(?:Z|([+-])([\d|:]*))?$/

/**
 * TODO: remove prototype polluting extension
 * JSON.parse reviver that converts ISO 8601 date strings into Date objects.
 * Replaces the `json.date-extensions` CJS library with a native ESM
 * implementation to avoid bundler compatibility issues.
 */
function dateReviver(_key: string, value: unknown): unknown {
  if (typeof value === 'string' && reISO.test(value)) {
    return new Date(value)
  }
  return value
}

/** Replace the global JSON.parse with a date-aware version. */
function installDateParser(): void {
  const originalParse = JSON.parse
  JSON.parse = function (
    text: string,
    reviver?: Parameters<typeof JSON.parse>[1]
  ) {
    return originalParse(text, (key, value) => {
      const processed = dateReviver(key, value)
      return reviver ? reviver(key, processed) : processed
    })
  }
}

export function extendDateType() {
  installDateParser()

  // how many ms there are in the empty date "0001-01-01T00:00:00"
  const emptyDateMilliseconds = -62135579038000

  Date.prototype.isEmpty = function isEmpty() {
    return this.getTime() === emptyDateMilliseconds
  }

  Date.prototype.isNotEmpty = function isNotEmpty() {
    return !this.isEmpty()
  }
}
